module.exports = __webpack_public_path__ + "static/media/fresh-factory-banner1.e04ff36c.jpg";